<template>
    <div id="testimonials-carousel" class="quote-slider-wrapper carousel slide" :class="addclass">
        <!-- Controls -->
        <a class="slider-arrow slider-left" href="#testimonials-carousel" role="button" data-slide="prev">
            <img src="images/arrowleft.png" alt="Previous">
        </a>
        <a class="slider-arrow slider-right" href="#testimonials-carousel" role="button" data-slide="next">
            <img src="images/arrowright.png" alt="Next">
        </a>

        <!-- Wrapper for slides -->
        <slot/>

        <!-- Indicators -->
        <div class="carousel-bottom">
            <ol class="carousel-indicators">
                <li data-target="#testimonials-carousel" data-slide-to="0" class="active"></li>
                <li data-target="#testimonials-carousel" data-slide-to="1"></li>
                <li data-target="#testimonials-carousel" data-slide-to="2"></li>
            </ol>
        </div>
    </div>
</template>

<script>
    export default {
        /**
         * How To (Safely) Use A jQuery Plugin With Vue.js
         * https://vuejsdevelopers.com/2017/05/20/vue-js-safely-jquery-plugin/
         */
        name: 'testimonials',
        props: {
            addclass: {
                type: String,
                required: false,
                default: ''
            }
        },
        mounted: function () {
            window.$(this.$el).carousel({
                // wrap: false,
                // interval: false,
                interval: 7000,
                ride: 'carousel'
            })
        },
        beforeDestroy: function () {
            // window.$(this.$el).carousel('dispose');
        }
    }
</script>



// WEBPACK FOOTER //
// Testimonials.vue?51640b87